<template>
    <div class="message-container">
        <div class="md-icon">check_circle</div>
        <div class="title">{{ $t('login_successfull') }}</div>
        <div class="subtitle">{{ $t('login_successfull_info') }}</div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'login-home',
        created() {
            if (Object.keys(this.$route.query).length > 0) {
                this.$router.replace({ query: {} });
            }
        },
    });

</script>


<style scoped lang="scss">

    .message-container {
        margin: 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        text-align: center;

        .title {
            @extend %headline-h2;
        }

        .subtitle {
            @extend %body-16-regular;
            color: var(--grey-700);
        }

        .md-icon {
            font-size: 48px;
            color: var(--success-700);
        }
    }
</style>